import Swal from 'sweetalert2';
import { validateOverrideCode } from './utils.common';
function sweetAlertTwoButtons(title, text, type, confirmButtonText, cancelButtonText?) {
    const swalFormat = {
        title,
        text,
        type,
        showCancelButton: cancelButtonText ? true : false,
        confirmButtonColor: cancelButtonText ? '#d33' : '#5163B7',
        cancelButtonColor: '#5163B7',
        confirmButtonText,
        cancelButtonText

    };
    return swalFormat;
    // return Swal.fire(
    //     swalFormat
    //   );
}

function sweetAlertOneButtons(title, text, type, confirmButtonText) {
    const swalFormat = {
        title,
        text,
        type,
        confirmButtonColor: type === 'warning' || type === 'error' ? '#d33' : '#5163B7',
        confirmButtonText

    };
    return swalFormat;
    // return Swal.fire(
    //     swalFormat
    //   );
}

export function sweetAlert(title, text, type, confirmButtonText, cancelButtonText?) {
    if (arguments.length === 4) {
        return Swal.fire(
            sweetAlertOneButtons(title, text, type, confirmButtonText)
        );
    } else if (arguments.length === 5) {
        return Swal.fire(
            sweetAlertTwoButtons(title, text, type, confirmButtonText, cancelButtonText)
        );
    }
}

export function sweetAlertWithInput(title, text, type, confirmButtonText, cancelButtonText?,  inputField?: boolean,  inputPlaceholder?: string,  isAfterShift:boolean = false, user?: any)
 {
  const swalFormat: any = {
    title,
    text,
    icon: type, // SweetAlert2 uses `icon`, not `type`
    showCancelButton: !!cancelButtonText,
    confirmButtonColor: cancelButtonText ? '#d33' : '#5163B7',
    cancelButtonColor: '#5163B7',
    confirmButtonText,
    cancelButtonText,
  };

  if (inputField) {
    let htmlContent = `
      <p>${text}</p>
      <textarea id="swal-textarea" class="swal2-textarea" placeholder="${inputPlaceholder || 'Enter your note here'}" style="height: 80px;"></textarea>
    `;

    if (isAfterShift) {
      htmlContent += `
        <label for="swal-personal-code" style="display: block; text-align: left; margin-top: 5px; margin-bottom: 2px; font-weight: 500;">Authorization Code</label>
        <input id="swal-personal-code" class="swal2-input" type="text" style="margin-top: 0;">
      `;
    }

    swalFormat.html = htmlContent;
    swalFormat.text = undefined;
    swalFormat.focusConfirm = false;
    swalFormat.preConfirm = () => {
      const textarea = (document.getElementById('swal-textarea') as HTMLTextAreaElement).value;

      if (!textarea || textarea.trim().length < 10) {
        Swal.showValidationMessage('Please write at least 10 characters in the note.');
        return false;
      }

      if (isAfterShift) {
        const personalCode = (document.getElementById('swal-personal-code') as HTMLInputElement).value;

        if (!personalCode || personalCode.trim() === '') {
          Swal.showValidationMessage('Please enter your personal code.');
          return false;
        }

         const companyId = user && user.company ? user.company._id : user._id;
         const codeValidity = validateOverrideCode(companyId, personalCode)
        if (!codeValidity) {
          Swal.showValidationMessage('Personal code is not valid.');
          return false;
        }
        return { note: textarea, personalCode: personalCode };
      }

      return { note: textarea };
    };
  }

  return Swal.fire(swalFormat);
}

export function sweetAlertWithSelector(
  title: string,
  text: string,
  type: 'success' | 'error' | 'warning' | 'info' | 'question',
  confirmButtonText: string,
  cancelButtonText?: string,
  selectorOptions?: string[],
  inputPlaceholder?: string,
  preSelectedOption?: string
) {
  const swalFormat: any = {
    title,
    text,
    icon: type,
    showCancelButton: !!cancelButtonText,
    confirmButtonColor: cancelButtonText ? '#d33' : '#5163B7',
    cancelButtonColor: '#5163B7',
    confirmButtonText,
    cancelButtonText,
    input: 'select',
    inputPlaceholder: inputPlaceholder || 'Select an option',
    inputOptions: {},
  };

  // Populate selector options + add "None" at top
  if (selectorOptions && selectorOptions.length) {
    swalFormat.inputOptions = selectorOptions.reduce(
      (acc, opt) => {
        acc[opt] = opt;
        return acc;
      },
      { '': 'None' } as Record<string, string>
    );

    // Preselect if valid, otherwise default to "None"
    swalFormat.inputValue =
      preSelectedOption && selectorOptions.includes(preSelectedOption)
        ? preSelectedOption
        : '';
  }

  // Return Swal promise with clear detection
  return Swal.fire(swalFormat);
}

export function sweetAlertWithMultiSelector(
  title: string,
  text: string,
  type: 'success' | 'error' | 'warning' | 'info' | 'question',
  confirmButtonText: string,
  cancelButtonText?: string,
  selectorOptions: string[] = [],
  preSelectedOptions: string[] = [],
  clearOptionLabel: string = 'None'
) {
  // Build select options HTML
  const optionsHtml = [
    `<option value="">${clearOptionLabel}</option>`,
    ...selectorOptions.map(
      opt =>
        `<option value="${opt}" ${
          preSelectedOptions.includes(opt) ? 'selected' : ''
        }>${opt}</option>`
    ),
  ].join('');
      // <p style="margin-bottom:8px;">${text}</p>
      // <select id="multiSelector" class="swal2-select" multiple style="width:100%; height:120px;">
      //   ${optionsHtml}
      // </select>
  const swalFormat: any = {
    title,
    html: ` <ng-select [items]="${selectorOptions}" [clearable]="false" [multiple]="true"
            [closeOnSelect]="false" bindValue="title" bindLabel="title" placeholder="-- Select Appointment Type --"
            class="p-0 form-control block w-full rounded-md text-main-secondary placeholder:text-main-light border border-main-base shadow-sm focus:border-main-primary focus:ring-main-primary text-sm"
            [searchable]="true">

            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <input id="item-{{index}}" type="checkbox" [ngModelOptions]="{standalone: true}"
                [ngModel]="item$.selected" /> {{item.title}}
            </ng-template>
          </ng-select>
    `,
    icon: type,
    showCancelButton: !!cancelButtonText,
    confirmButtonColor: cancelButtonText ? '#d33' : '#5163B7',
    cancelButtonColor: '#5163B7',
    confirmButtonText,
    cancelButtonText,
    focusConfirm: false,
    preConfirm: () => {
      const selectEl = document.getElementById('multiSelector') as HTMLSelectElement;
      if (!selectEl) return [];
      const selected = Array.from(selectEl.selectedOptions).map(opt => opt.value);
      return selected;
    },
  };

  return Swal.fire(swalFormat);
}



